/**
 * @generated SignedSource<<580dbe7f8e1c029c6fd0a0c1f53d16ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type quickSearchDialogResultsResultQuery$variables = {
  filter: string;
};
export type quickSearchDialogResultsResultQuery$data = {
  readonly quickSearch: ReadonlyArray<{
    readonly name: string;
    readonly results: ReadonlyArray<{
      readonly title: string;
      readonly url: string;
    }>;
  }>;
};
export type quickSearchDialogResultsResultQuery = {
  response: quickSearchDialogResultsResultQuery$data;
  variables: quickSearchDialogResultsResultQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "ResultCategory",
    "kind": "LinkedField",
    "name": "quickSearch",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Result",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "quickSearchDialogResultsResultQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "quickSearchDialogResultsResultQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2fdad7bd2875ca69ab368a1d939ad8f0",
    "id": null,
    "metadata": {},
    "name": "quickSearchDialogResultsResultQuery",
    "operationKind": "query",
    "text": "query quickSearchDialogResultsResultQuery(\n  $filter: String!\n) {\n  quickSearch(filter: $filter) {\n    name\n    results {\n      title\n      url\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b69c6b4b54ffbbf20069248b4f89137";

export default node;
